/* Product Page Pro — assets/product-page-pro.js
 * No dependencies. Works for multiple instances of the section on one page.
 */
(function () {
  'use strict';

  function initPdp(root) {
    var sectionId = root.dataset.sectionId;
    var settings = (window.pdpSectionSettings && window.pdpSectionSettings[sectionId]) || {};

    var variantDataEl = root.querySelector('#PdpVariantData-' + sectionId);
    if (!variantDataEl) return;

    var variants = [];
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      variants = [];
    }

    var form = root.querySelector('#PdpForm-' + sectionId);
    var variantIdInput = root.querySelector('#PdpVariantId-' + sectionId);
    var priceWrap = root.querySelector('#PdpPrice-' + sectionId);
    var skuWrap = root.querySelector('#PdpSku-' + sectionId);
    var addBtn = root.querySelector('#PdpAddToCart-' + sectionId);
    var addBtnText = addBtn ? addBtn.querySelector('[data-add-to-cart-text]') : null;
    var formError = root.querySelector('#PdpFormError-' + sectionId);
    var optionsWrap = root.querySelector('#PdpVariants-' + sectionId);
    var qtyInput = root.querySelector('#PdpQty-' + sectionId);

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.pdp__thumb-btn'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('.pdp__stage-slide'));
    var stageTrack = root.querySelector('#PdpStageTrack-' + sectionId);
    var thumbsWrap = root.querySelector('#PdpThumbs-' + sectionId);

    var selectedOptions = [];
    if (optionsWrap) {
      optionsWrap.querySelectorAll('.pdp__option').forEach(function (optEl) {
        var idx = parseInt(optEl.dataset.optionIndex, 10);
        var activeEl = optEl.querySelector('.is-active[data-value]');
        selectedOptions[idx] = activeEl ? activeEl.dataset.value : null;
      });
    }

    function money(cents) {
      if (typeof cents !== 'number') return '';
      var format = settings.moneyFormat || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return format.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (selectedOptions[j] != null && v.options[j] !== selectedOptions[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function goToMedia(mediaId) {
      if (!mediaId) return;
      var slide = slides.filter(function (s) { return s.dataset.mediaId === String(mediaId); })[0];
      var thumb = thumbs.filter(function (t) { return t.dataset.mediaId === String(mediaId); })[0];
      if (slide && stageTrack) {
        slides.forEach(function (s) { s.classList.remove('is-active'); });
        slide.classList.add('is-active');
      }
      if (thumb && thumbsWrap) {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    function updateUI(variant) {
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addBtnText) addBtnText.textContent = 'Unavailable';
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceWrap) {
        var currentEl = priceWrap.querySelector('.pdp__price-current');
        var compareEl = priceWrap.querySelector('.pdp__price-compare');
        var badgeEl = priceWrap.querySelector('.pdp__price-badge');
        if (currentEl) currentEl.textContent = money(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (!compareEl) {
            compareEl = document.createElement('span');
            compareEl.className = 'pdp__price-compare';
            priceWrap.appendChild(compareEl);
          }
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.style.display = '';
          if (!badgeEl) {
            badgeEl = document.createElement('span');
            badgeEl.className = 'pdp__price-badge';
            priceWrap.appendChild(badgeEl);
          }
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          badgeEl.textContent = pct + '% OFF';
          badgeEl.style.display = '';
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (badgeEl) badgeEl.style.display = 'none';
        }
      }

      if (skuWrap) skuWrap.textContent = 'SKU: ' + (variant.sku || '—');

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addBtnText) addBtnText.textContent = variant.available
          ? (addBtn.dataset.labelAvailable || addBtnText.textContent || 'Add to Cart')
          : 'Sold Out';
      }

      if (optionsWrap) {
        optionsWrap.querySelectorAll('.pdp__option').forEach(function (optEl) {
          var idx = parseInt(optEl.dataset.optionIndex, 10);
          var selectedLabel = optEl.querySelector('[data-selected-value]');
          if (selectedLabel) selectedLabel.textContent = variant.options[idx];
        });
      }

      if (variant.featured_media && variant.featured_media.id) {
        goToMedia(variant.featured_media.id);
      }

      if (history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }

    // ---- option click handling ----
    if (optionsWrap) {
      optionsWrap.addEventListener('click', function (e) {
        var target = e.target.closest('[data-value]');
        if (!target) return;
        var idx = parseInt(target.dataset.optionIndex, 10);
        selectedOptions[idx] = target.dataset.value;

        var optEl = target.closest('.pdp__option');
        optEl.querySelectorAll('[data-value]').forEach(function (el) { el.classList.remove('is-active'); });
        target.classList.add('is-active');

        var variant = findVariant();
        updateUI(variant);
      });
    }

    // ---- gallery navigation ----
    if (thumbsWrap) {
      thumbsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.pdp__thumb-btn');
        if (!btn) return;
        goToMedia(btn.dataset.mediaId);
      });
    }

    function stepSlide(dir) {
      var activeIndex = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (activeIndex === -1) activeIndex = 0;
      var nextIndex = (activeIndex + dir + slides.length) % slides.length;
      var nextSlide = slides[nextIndex];
      if (nextSlide) goToMedia(nextSlide.dataset.mediaId);
    }
    var prevBtn = root.querySelector('[data-pdp-prev]');
    var nextBtn = root.querySelector('[data-pdp-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { stepSlide(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stepSlide(1); });

    // ---- quantity stepper ----
    var minusBtn = root.querySelector('[data-qty-minus]');
    var plusBtn = root.querySelector('[data-qty-plus]');
    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = val;
      });
    }
    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function () {
        var val = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.value = val;
      });
    }

    // ---- size guide modal ----
    var sizeGuideModal = root.querySelector('#PdpSizeGuide-' + sectionId);
    root.querySelectorAll('[data-size-guide-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (sizeGuideModal) {
          sizeGuideModal.hidden = false;
          document.body.classList.add('pdp-modal-open');
        }
      });
    });
    if (sizeGuideModal) {
      sizeGuideModal.querySelectorAll('[data-size-guide-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeGuideModal.hidden = true;
          document.body.classList.remove('pdp-modal-open');
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !sizeGuideModal.hidden) {
          sizeGuideModal.hidden = true;
          document.body.classList.remove('pdp-modal-open');
        }
      });
    }

    // ---- add to cart (AJAX, updates cart drawer via Sections API) ----
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;

        if (formError) {
          formError.hidden = true;
          formError.textContent = '';
        }
        addBtn.classList.add('is-loading');
        addBtn.disabled = true;

        var formData = new FormData(form);
        var body = {
          items: [
            {
              id: formData.get('id'),
              quantity: parseInt(formData.get('quantity'), 10) || 1
            }
          ],
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        };

        fetch((settings.cartAddUrl || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            addBtn.classList.remove('is-loading');
            var variant = findVariant();
            addBtn.disabled = variant ? !variant.available : false;

            if (!result.ok) {
              var message = (result.data && result.data.description) || 'Could not add item to cart.';
              if (formError) {
                formError.hidden = false;
                formError.textContent = message;
              }
              return;
            }

            if (result.data.sections && result.data.sections['cart-drawer']) {
              document.dispatchEvent(new CustomEvent('cart-drawer:render', {
                detail: { html: result.data.sections['cart-drawer'] }
              }));
            }
            document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          })
          .catch(function () {
            addBtn.classList.remove('is-loading');
            addBtn.disabled = false;
            if (formError) {
              formError.hidden = false;
              formError.textContent = 'Something went wrong. Please try again.';
            }
          });
      });
    }
  }

  function init() {
    document.querySelectorAll('.pdp[data-section-id]').forEach(initPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.pdp[data-section-id]');
    if (root) initPdp(root);
  });
})();
